const getStatusBadge = (status?: string): string => {
  switch (status) {
    case 'picked up':
      return 'badge-success'
    case 'found':
      return 'badge-warning'
    case 'notfound':
      return 'badge-error'
    default:
      return 'badge-base'
  }
}

interface ProfinderStatusBadgeProps {
  status?: string
  small?: boolean
}

const ProfinderStatusBadge = ({ status, small }: ProfinderStatusBadgeProps) => {
  if (!status) return null
  return (
    <span
      className={`badge ${getStatusBadge(status)} ${small ? 'badge-sm' : ''}`}
    >
      {status.toUpperCase().replace(/-/g, ' ')}
    </span>
  )
}

export { ProfinderStatusBadge }
